<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Droit d'accès</h1>
                    <p>Gestion des droits et roles utilisateurs</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('is_super_admin')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer</span>
                </li>
              </actions-dropdown>

            </div>
        </header>
        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>

                            <div></div>
                            <div>
                                <span>Model authorizations</span>
                            </div>
                            <div class="actions"></div>
                            <div></div>

                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.model_name)" v-bind:class="setClassDataRaw( 'is_super_admin')">
                            <div></div>
                            <div data-field="name">
                                <span class="branch-name">{{ item.model_name }}</span>
                            </div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('is_super_admin')"><button @click="remove(item.model_name)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('is_super_admin')"><button @click="edit(item.model_name)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>

            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>

    import AclModelService from './AclModelService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                dataSelectedFilter: null,
                models: [],
                permissions: null,
                resources: null
            }
        },
        mounted: function(){
            this.refresh();
        },
        methods: {
            getResource: function(){
                return AclModelService;
            },
            refresh: function(){
                AclModelService.query().then(response => {
                    this.resources = response.data;
                    setTimeout(function(){
                        if( field ){
                            var els = document.querySelectorAll("[data-field]");
                            for (var i = 0, len = els.length; i < len; i++) {
                                els[i].className = els[i].className.replace(" active", "");
                                if( els[i].getAttribute("data-field") == field){
                                    els[i].className += " active";
                                }
                            }
                        }
                    }, 1)
                    this.resourceLoaded();
                });
            },
            edit: function(model, route){
                model = model.split('\\').join('.')
                let name = this.$route.name + '-edit'
                console.log('ROUTE NAME = '+name);
                this.$router.push({ name: name, params: {model: model}});
            },
            remove: function(model){
                let ask = confirm("Etes-vous certain de vouloir supprimer cet élément ?");
                if( ask && this.getResource() ){

                    model = model.split('\\').join('.')

                    this.getResource().delete(model).then((response) => {
                        this.refresh()
                    })
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/authorizations/Index.vue